import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let metalCache = null;
let inflight = null;
const listeners = new Set();

async function loadMetals() {
  if (!inflight) {
    inflight = fetch(`${API}/metals`)
      .then((r) => {
        if (!r.ok) throw new Error("metals unavailable");
        return r.json();
      })
      .then((d) => {
        metalCache = d;
        listeners.forEach((l) => l(d));
      })
      .catch(() => {})
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function useMetals() {
  const [data, setData] = useState(metalCache);
  useEffect(() => {
    const listener = (d) => setData(d);
    listeners.add(listener);
    if (!metalCache) loadMetals();
    const t = setInterval(loadMetals, 60000);
    return () => {
      listeners.delete(listener);
      clearInterval(t);
    };
  }, []);
  return data;
}

export function useConfig() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    fetch(`${API}/config`)
      .then((r) => r.json())
      .then(setCfg)
      .catch(() => {});
  }, []);
  return cfg;
}

export async function postJSON(path, body) {
  const r = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!r.ok) throw new Error(`Request failed: ${r.status}`);
  return r.json();
}

export const fmtMoney = (n, currency = "EUR") =>
  new Intl.NumberFormat("en-IE", { style: "currency", currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
